/**
 * 스테이지 도구 칸(상품 변경·이미지 업로드·텍스트) — 흰 사각 칸에 아이콘과 한국어 글자. 버튼·링크가 함께 쓴다.
 * 칸 사이는 얇은 선으로 나누고(목록 쪽 divide), 누르면 흑연 바탕 + 라임 글자로 뒤집힌다(사이트 CTA 와 같은 짝).
 */
export const RAIL_ITEM_STYLES = {
  item: 'group/rail flex min-h-16 min-w-0 flex-1 cursor-pointer flex-col items-center justify-center gap-1.5 bg-background px-2 py-3 text-xs font-medium text-foreground transition-colors hover:bg-primary hover:text-primary-foreground focus-visible:relative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring disabled:cursor-not-allowed disabled:text-foreground/35 disabled:hover:bg-background disabled:hover:text-foreground/35 lg:min-h-20 lg:w-full lg:flex-none',
  icon: 'size-5 shrink-0',
} as const;
